"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSizes = void 0;
const bam_1 = require("./sizes/bam");
const relic_1 = require("./sizes/relic");
const tickethead_1 = require("./sizes/tickethead");
const branding_1 = require("./branding");
/**
 * Get size definition based on branding
 * @param branding
 * @returns
 */
const getSizes = (branding) => {
    switch (branding) {
        case branding_1.BrandingType.RELIC:
            return relic_1.sizes;
        case branding_1.BrandingType.TICKETHEAD:
            return tickethead_1.sizes;
        default:
            return bam_1.sizes;
    }
};
exports.getSizes = getSizes;
//# sourceMappingURL=sizes.js.map